import * as React from "react";
import { memo } from "react";
const SvgMaximize = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m10-1.6667e-6v10h-10v-10zm-1.001 1.001h-7.998v7.998h7.998z", strokeWidth: 0.25 }));
const Memo = memo(SvgMaximize);
export default Memo;
